<div class="file-preview-modal-container">
  <!-- Top Navigation & Actions Bar -->
  <div class="preview-top-bar">
    <div class="file-identity-wrapper">
      <mat-icon *ngIf="isPdf" class="doc-icon pdf-icon">picture_as_pdf</mat-icon>
      <mat-icon *ngIf="isDoc" class="doc-icon docx-icon">description</mat-icon>
      <mat-icon *ngIf="isImage" class="doc-icon image-icon">image</mat-icon>
      <mat-icon *ngIf="!isPdf && !isDoc && !isImage" class="doc-icon generic-icon">insert_drive_file</mat-icon>

      <div class="file-text-meta">
        <div class="file-title-row">
          <span class="file-name-title" [title]="fileName">{{ fileName }}</span>
          <span *ngIf="category" class="category-pill">{{ category }}</span>
        </div>
        <span *ngIf="fileSizeBytes" class="file-size-subtitle">{{ formatFileSize(fileSizeBytes) }}</span>
      </div>
    </div>

    <div class="preview-actions-wrapper">
      <button
        *ngIf="data?.artifactId"
        mat-stroked-button
        class="action-btn share-action"
        (click)="shareFile()"
        matTooltip="Generate secure presigned share link"
      >
        <mat-icon class="btn-icon">share</mat-icon>
        <span>Share</span>
      </button>

      <button
        mat-stroked-button
        color="primary"
        class="action-btn download-action"
        (click)="downloadFile()"
        matTooltip="Download file attachment"
      >
        <mat-icon class="btn-icon">file_download</mat-icon>
        <span>Download</span>
      </button>

      <button
        mat-icon-button
        class="icon-action-btn"
        (click)="openInNewTab()"
        matTooltip="Open in dedicated browser tab"
      >
        <mat-icon>open_in_new</mat-icon>
      </button>

      <button
        mat-icon-button
        class="icon-action-btn close-action-btn"
        (click)="close()"
        matTooltip="Close preview (ESC)"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Main Viewer Viewport -->
  <div class="preview-viewport">
    <!-- Loading Spinner Overlay -->
    <div *ngIf="isLoading && !hasError && !isDoc" class="preview-loading-overlay">
      <div class="loading-content-box">
        <mat-spinner diameter="44"></mat-spinner>
        <div class="loading-text-meta">
          <span class="loading-title">Loading Document Preview...</span>
          <span class="loading-sub">Streaming encrypted file stream from vault...</span>
        </div>
      </div>
    </div>

    <!-- Error / Fallback State Overlay -->
    <div *ngIf="hasError" class="preview-error-overlay">
      <div class="fallback-card">
        <div class="fallback-icon-bubble">
          <mat-icon>insert_drive_file</mat-icon>
        </div>
        <h3 class="fallback-title">Inline Preview Not Available</h3>
        <p class="fallback-desc">This document format or browser security policy prevents direct embedding. You can download or open it directly in a dedicated browser tab.</p>
        <div class="fallback-actions">
          <button mat-flat-button color="primary" class="fallback-btn" (click)="downloadFile()">
            <mat-icon>file_download</mat-icon>
            <span>Download File</span>
          </button>
          <button mat-stroked-button class="fallback-btn secondary" (click)="openInNewTab()">
            <mat-icon>open_in_new</mat-icon>
            <span>Open in New Tab</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Word Document (DOC / DOCX) Dedicated Card View -->
    <div *ngIf="isDoc && !hasError" class="doc-viewer-wrapper">
      <div class="doc-card">
        <div class="doc-icon-bubble">
          <mat-icon>description</mat-icon>
        </div>
        <h3 class="doc-title">{{ fileName }}</h3>
        <div class="doc-badge-pill">MICROSOFT WORD DOCUMENT</div>
        <p class="doc-desc">
          This document is stored in Microsoft Word (.docx / .doc) format. You can download the original file to view or edit, or open it in your default application.
        </p>

        <div class="doc-meta-row" *ngIf="fileSizeBytes">
          <div class="meta-item">
            <span class="meta-label">File Size:</span>
            <span class="meta-value">{{ formatFileSize(fileSizeBytes) }}</span>
          </div>
          <div class="meta-item" *ngIf="category">
            <span class="meta-label">Category:</span>
            <span class="meta-value">{{ category }}</span>
          </div>
        </div>

        <div class="doc-actions-row">
          <button mat-flat-button color="primary" class="doc-action-btn primary-btn" (click)="downloadFile()">
            <mat-icon>file_download</mat-icon>
            <span>Download Document</span>
          </button>
          <button mat-stroked-button class="doc-action-btn secondary-btn" (click)="openInNewTab()">
            <mat-icon>open_in_new</mat-icon>
            <span>Open in Tab</span>
          </button>
          <button *ngIf="data?.artifactId" mat-stroked-button class="doc-action-btn share-link-btn" (click)="shareFile()">
            <mat-icon>share</mat-icon>
            <span>Share Link</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Image Viewer -->
    <div *ngIf="isImage && !isDoc && !hasError" class="image-viewer-wrapper">
      <img
        [src]="resolvedViewUrl"
        [alt]="fileName"
        class="preview-image"
        (load)="onLoad()"
        (error)="onError()"
      />
    </div>

    <!-- PDF & Document Iframe Viewer -->
    <ng-container *ngIf="!isImage && !isDoc && safeFileUrl && !hasError">
      <iframe
        [src]="safeFileUrl"
        class="preview-iframe"
        frameborder="0"
        allowfullscreen
        (load)="onLoad()"
        (error)="onError()"
      ></iframe>
    </ng-container>
  </div>
</div>
